import { AGENT_TEXT_DEFAULT_MAX, escapeAgentString } from './escapeAgentString';

/**
 * An agent-supplied string, escaped (see agentText.ts), monospace and length-capped. Always React text nodes: never
 * dangerouslySetInnerHTML. `null` reads "Not reported".
 */
export function AgentText({
  value,
  max = AGENT_TEXT_DEFAULT_MAX,
  className,
}: {
  value: string | null | undefined;
  max?: number;
  className?: string;
}) {
  if (value === null || value === undefined) return <span className="text-muted-foreground">Not reported</span>;
  const r = escapeAgentString(value, max);
  return (
    <code
      dir="ltr"
      className={`break-all font-mono ${className ?? ''}`}
      title={r.hadHidden ? 'Contains hidden or non-ASCII characters, shown as \\u{code}.' : undefined}
    >
      {r.parts.map((p, i) =>
        p.escaped ? (
          <span key={i} className="rounded bg-status-red/15 px-0.5 text-status-red">
            {p.text}
          </span>
        ) : (
          <span key={i}>{p.text}</span>
        ),
      )}
    </code>
  );
}
